<template>
    <div class="p-3">
        {{ message }}
    </div>
</template>

<script setup lang="ts">
defineProps<{ message: string }>()
</script>

<style scoped>

</style>
